<template>
  <div
    v-show="showDropDown"
    class="fixed top-0 right-0 z-30 w-screen min-h-screen bg-transparent"
    @click.self="handleShowDropDown"
  ></div>
  <div class="relative">
    <button @click="handleShowDropDown">
      <img src="../../../assets/svg/moreOption.svg" class="mt-1 h-7" />
    </button>

    <div
      v-show="showDropDown"
      class="absolute border-borderType z-50 rounded-lg border w-[200px] px-3 right-[4px] bg-white p-2"
    >
      <div
        class="flex items-center my-4 text-sm cursor-pointer"
        v-for="(option, index) in options"
        :key="index"
      >
        <!-- Delete -->
        <span
          v-if="option.name.toLowerCase() === 'delete'"
          @click="option.func"
          class="ml-2 text-red-600"
        >
          <span v-if="!deleteLoader"> {{ option.name }}</span>
          <ClipLoader v-else size="12px" color="red" />
        </span>
        <!--  -->

        <!-- reset password -->
        <span
          v-if="option.name.toLowerCase() === 'reset password'"
          @click="option.func"
          class="ml-2"
        >
          <span v-if="!resetLoader"> {{ option.name }}</span>
          <ClipLoader v-else size="12px" color="grey" />
        </span>
        <!--  -->

        <!-- suspend & activate -->
        <span
          v-if="
            option.name.toLowerCase() === 'suspend' ||
            option.name.toLowerCase() === 'activate'
          "
          @click="option.func"
          class=""
          :class="
            option.name.toLowerCase() === 'suspend'
              ? 'text-yellow-600 ml-4'
              : option.name.toLowerCase() === 'activate'
              ? 'text-green-600 ml-4'
              : option.name.toLowerCase() === 'credit limit'
              ? 'text-green-600'
              : 'black'
          "
        >
          <span v-if="!suspendLoader"> {{ option.name }}</span>
          <ClipLoader v-else size="12px" color="grey" />
        </span>
        <!--  -->

        <span
          v-if="
            option.name.toLowerCase() !== 'reset password' &&
            option.name.toLowerCase() !== 'suspend' &&
            option.name.toLowerCase() !== 'activate' &&
            option.name.toLowerCase() !== 'delete'
          "
          @click="
            option.name.toLowerCase() === 'edit' ||
            option.name.toLowerCase() === 'map product'
              ? option.func('open')
              : option.func()
          "
          class="ml-2"
          :class="
            option.name.toLowerCase() === 'delete' ? 'text-red-600' : 'black'
          "
        >
          <FlexWrapper>
            <span v-if="option.icon">
              <img :src="option.icon" />
            </span>
            <span class="pl-2">
              {{ option.name }}
            </span>
          </FlexWrapper>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
//libraries
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";

export default {
  name: "MoreOption",
  props: [
    "options",
    "suspendLoader",
    "resetLoader",
    "deleteLoader",
    "editHandler",
  ],

  components: { ClipLoader, FlexWrapper },
  data() {
    return {
      showDropDown: false,
    };
  },
  mounted() {
  },
  methods: {
    handleShowDropDown() {
      this.showDropDown = !this.showDropDown;
    },
  },
};
</script>

<style></style>
